import { useEffect } from 'react';

import { useTrackOnce } from '#src/app/shared/hooks/tracking';

type UseTrackDmrlArgs = {
	isDmrlEnabled: boolean;
	decisionMakerId: string;
};

export function useTrackDmrlView({ isDmrlEnabled, decisionMakerId }: UseTrackDmrlArgs) {
	const track = useTrackOnce();

	useEffect(() => {
		if (isDmrlEnabled) {
			void track('dmrl_page_view', {
				decision_maker_id: decisionMakerId,
			});
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}
